/* eslint-disable */
/*
 * jquery.ajax-retry
 * https://github.com/johnkpaul/jquery-ajax-retry
 *
 * Copyright (c) 2012 John Paul
 * Licensed under the MIT license.
 */
import $ from "jquery";

export function ajaxPrefilter() {
  // enhance all ajax requests with our retry API
  $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    jqXHR.retry = function (opts) {
      if (opts.timeout) {
        this.timeout = opts.timeout;
      }
      if (opts.statusCodes) {
        this.statusCodes = opts.statusCodes;
      }
      if (opts.retryCondition) {
        this.retryCondition = opts.retryCondition;
      }
      return this.pipe(null, pipeFailRetry(this, opts));
    };
  });
}

// generates a fail pipe function that will retry `jqXHR` `times` more times
function pipeFailRetry(jqXHR, opts) {
  var retryCount = opts.retryCount || 0;
  var times = opts.times;
  var timeout = jqXHR.timeout;

  jqXHR.isRetry = true;

  // takes failure data as input, returns a new deferred
  return function (input, status, msg) {
    var ajaxOptions = this;
    var output = new $.Deferred();
    var retryAfter = jqXHR.getResponseHeader("Retry-After");

    var retryDelay = function (times) {
      if (typeof timeout === "function") {
        return timeout(times, input);
      }
      if (typeof timeout === "number") {
        return timeout;
      }
    };

    // whenever we do make this request, pipe its output to our deferred
    function nextRequest() {
      ajaxOptions.times = times;

      $.ajax(ajaxOptions)
        .retry({
          times: opts.times,
          retryCount: retryCount + 1,
          timeout: opts.timeout,
          statusCodes: opts.statusCodes,
          retryCondition: opts.retryCondition
        })
        .pipe(output.resolve, output.reject);
    }
    if (
      input.statusText !== "abort" &&
      retryCount < times &&
      (!jqXHR.statusCodes || $.inArray(input.status, jqXHR.statusCodes) > -1) &&
      (!jqXHR.retryCondition || jqXHR.retryCondition(ajaxOptions))
    ) {
      // implement Retry-After rfc
      // http://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.37
      if (retryAfter) {
        // it must be a date
        if (isNaN(retryAfter)) {
          timeout = new Date(retryAfter).getTime() - $.now();
          // its a number in seconds
        } else {
          timeout = parseInt(retryAfter, 10) * 1000;
        }
        // ensure timeout is a positive number
        if (isNaN(timeout) || timeout < 0) {
          timeout = jqXHR.timeout;
        }
      } else {
        timeout = retryDelay(retryCount);
      }
      if (timeout !== undefined) {
        setTimeout(nextRequest, timeout);
      } else {
        nextRequest();
      }
    } else {
      // no times left, reject our deferred with the current arguments
      output.rejectWith(this, arguments);
    }

    return output;
  };
}

const SAFE_HTTP_METHODS = ["get", "head", "options"];
// const IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat(["put", "delete"]);

const DEFAULT_OPTIONS = {
  times: 3,
  timeout: exponentialDelay,
  retryCondition: ajaxOptions =>
    SAFE_HTTP_METHODS.indexOf(ajaxOptions.type.toLowerCase()) !== -1,
  statusCodes: [0, 500, 502, 503, 504]
};

export function exponentialDelay(retryNumber = 0, error, delayFactor = 100) {
  const delay = 2 ** retryNumber * delayFactor;
  const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
  return delay + randomSum;
}

export function ajaxRetrySetup(options = DEFAULT_OPTIONS) {
  ajaxPrefilter();
  $(document).on("ajaxError", (event, jqXHR, context, error) => {
    if (context.times !== undefined) {
      return;
    }
    if (options.timeout) {
      jqXHR.timeout = options.timeout;
    }
    if (options.statusCodes) {
      jqXHR.statusCodes = options.statusCodes;
    }
    if (options.retryCondition) {
      jqXHR.retryCondition = options.retryCondition;
    }
    pipeFailRetry(jqXHR, options).call(context, jqXHR, jqXHR.status, error);
  });
}
